import { twJoin } from 'tailwind-merge';

import type { Props as BaseButtonProps } from './BaseButton';
import { BaseButton } from './BaseButton';

export const DangerButton = ({ className, ...rest }: BaseButtonProps) => {
  return (
    <BaseButton
      {...rest}
      className={twJoin(
        'focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5  dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900',
        className,
      )}
    />
  );
};
